import React from 'react'
import { Footer, Navbar, Product } from "../components"

const Products = () => {
  return (
    <>
      <Navbar />
      <Product />
      <Footer />
    </>
  )
}

export default Products